// extracted by mini-css-extract-plugin
export const wrapper = "loading-module--wrapper--N2qFM";
export const overlay = "loading-module--overlay--Smhhb";
export const circleLoading = "loading-module--circleLoading--iIlTI";
export const linearLoading = "loading-module--linearLoading--XrxR3";